import { useState, useEffect } from 'react';
import {
  getClientContactFilesByContactId,
  getClientFilesByClientId,
  IClientFile,
} from 'wisestep-api';

const useClientFilesByClientId = (
  clientId?: string,
  clientContactId?: string,
  refresh?: boolean,
  entityType?: string
) => {
  const [files, setFiles] = useState<IClientFile[]>([]);

  useEffect(() => {
    const fetchFiles = async () => {
      let response;
      if (entityType === 'client') {
        response = await getClientFilesByClientId(clientId as string);
      } else if (entityType === 'contact') {
        response = await getClientContactFilesByContactId(clientContactId as string);
      }
      setFiles(response.data);
    };
    fetchFiles();
  }, [clientId, refresh]);

  return files;
};
export default useClientFilesByClientId;
